import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import LandingPage from "@/pages/LandingPage";
import AnalyzePage from "@/pages/AnalyzePage";
import ReportPage from "@/pages/ReportPage";
import TrendsPage from "@/pages/TrendsPage";
import AdminPage from "@/pages/AdminPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import SegmentPage from "@/pages/SegmentPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import RestoreProPage from "@/pages/RestoreProPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import RedditLandingPage from "@/pages/RedditLandingPage";
import LearnHubPage from "@/pages/LearnHubPage";
import LearnConceptPage from "@/pages/LearnConceptPage";
import CFOBooksWaitlistPage from "@/pages/CFOBooksWaitlistPage";
import CFOBooksDashboardPage from "@/pages/CFOBooksDashboardPage";
import ForIndustryPage from "@/pages/ForIndustryPage";
import SampleReportPage from "@/pages/SampleReportPage";
import BlogPage from "@/pages/BlogPage";
import BenchmarksIndexPage from "@/pages/BenchmarksIndexPage";
import BenchmarkPage from "@/pages/BenchmarkPage";
import ValuationPage from "@/pages/ValuationPage";
import ValuationIndustryPage from "@/pages/ValuationIndustryPage";
import FloatingFeedback from "@/components/FloatingFeedback";
import { usePageviewTracker } from "@/lib/pageviewTracker";

// Lives INSIDE <BrowserRouter> so `useLocation` resolves. Tracks every
// route change and posts to /api/track/pageview. Skips /admin and dev hosts.
function RouteTracker() {
  usePageviewTracker();
  return null;
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1F382E",
            color: "#F7F5F0",
            border: "1px solid #142922",
          },
        }}
      />
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/analyze" element={<AnalyzePage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/trends" element={<TrendsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/leaderboard/:slug" element={<SegmentPage />} />
          <Route path="/pay/success" element={<PaymentSuccessPage />} />
          <Route path="/pay/restore" element={<RestoreProPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/r/:slug" element={<RedditLandingPage />} />
          <Route path="/learn" element={<LearnHubPage />} />
          <Route path="/learn/:slug" element={<LearnConceptPage />} />
          <Route path="/cfo-books" element={<CFOBooksWaitlistPage />} />
          <Route path="/cfo-books/dashboard" element={<CFOBooksDashboardPage />} />
          <Route path="/for/:slug" element={<ForIndustryPage />} />
          <Route path="/sample-report" element={<SampleReportPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/benchmarks" element={<BenchmarksIndexPage />} />
          <Route path="/benchmarks/:industry/:concept" element={<BenchmarkPage />} />
          <Route path="/valuation" element={<ValuationPage />} />
          <Route path="/valuation/:industry" element={<ValuationIndustryPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <FloatingFeedback />
      </BrowserRouter>
    </div>
  );
}

export default App;
